/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pctsol_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Physiological saline: 0.9% w/v means 0.9 g of NaCl in 100 mL.`)
};

const es_pctsol_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solución salina fisiológica: 0.9% p/v significa 0.9 g de NaCl en 100 mL.`)
};

const de_pctsol_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Physiologische Kochsalzlösung: 0,9% w/v bedeutet 0,9 g NaCl in 100 mL.`)
};

const nl_pctsol_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fysiologisch zout: 0,9% g/v betekent 0,9 g NaCl in 100 mL.`)
};

const fr_pctsol_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solution saline physiologique : 0,9 % p/v signifie 0,9 g de NaCl dans 100 mL.`)
};

const it_pctsol_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soluzione fisiologica: 0,9% p/v significa 0,9 g di NaCl in 100 mL.`)
};

const pt_br2_pctsol_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solução salina fisiológica: 0,9% p/v significa 0,9 g de NaCl em 100 mL.`)
};

const pt_pctsol_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soro fisiológico: 0,9% m/v significa 0,9 g de NaCl em 100 mL.`)
};

const ja_pctsol_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`生理食塩水: 0.9% w/vは100 mLあたりNaCl 0.9 gを意味します。`)
};

const zh_pctsol_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`生理盐水：0.9% w/v 表示每 100 mL 中含 0.9 g NaCl。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pctsol_ex2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pctsol_ex2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pctsol_ex2", locale)
	if (locale === "en") return en_pctsol_ex2(inputs)
	if (locale === "es") return es_pctsol_ex2(inputs)
	if (locale === "de") return de_pctsol_ex2(inputs)
	if (locale === "nl") return nl_pctsol_ex2(inputs)
	if (locale === "fr") return fr_pctsol_ex2(inputs)
	if (locale === "it") return it_pctsol_ex2(inputs)
	if (locale === "pt-BR") return pt_br2_pctsol_ex2(inputs)
	if (locale === "pt") return pt_pctsol_ex2(inputs)
	if (locale === "ja") return ja_pctsol_ex2(inputs)
	return zh_pctsol_ex2(inputs)
};